"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TwingProfilerDumperBase {
    dump(profile) {
        return this.dumpProfile(profile);
    }
    dumpProfile(profile, prefix = '', sibling = false) {
        let start;
        if (profile.isRoot()) {
            this.root = profile.getDuration();
            start = profile.getName();
        }
        else {
            if (profile.isTemplate()) {
                start = this.formatTemplate(profile, prefix);
            }
            else {
                start = this.formatNonTemplate(profile, prefix);
            }
            prefix += sibling ? '│ ' : '  ';
        }
        let percent = this.root ? profile.getDuration() / this.root * 100 : 0;
        let str;
        if (profile.getDuration() * 1000 < 1) {
            str = start + '\n';
        }
        else {
            str = `${start} ${this.formatTime(profile, percent)}\n`;
        }
        let nCount = profile.getProfiles().length;
        let i = 0;
        for (let p of profile.getProfiles()) {
            str += this.dumpProfile(p, prefix, i + 1 !== nCount);
            i++;
        }
        return str;
    }
}
exports.TwingProfilerDumperBase = TwingProfilerDumperBase;
